document.addEventListener('contextmenu', event => event.preventDefault());

const historyCarousels = document.querySelectorAll('.histroy-slider');

historyCarousels.forEach(historyCarousel => {
  const sectionId = historyCarousel.dataset.id
  const carouselId = `#carousel-${sectionId}`
  const flktyCarousel = new Flickity( carouselId, {
    // options
    cellAlign: 'left',
    contain: true,
    freeScroll: true,
    /*wrapAround: true,*/
    prevNextButtons: true,
    pageDots: false
  });
})


class typingEffect extends HTMLElement {
  constructor() {
    super();
    this.typedTextEle = this.querySelector(".typedEffectText")
    this.effectTextSpan = this.querySelector(".typedText")
    this.typedText = this.effectTextSpan.innerHTML
    this.typedCursor = this.querySelector(".typedCursor")

    this.typingDelay = parseInt(this.dataset.typing);
    this.erasingDelay = parseInt(this.dataset.erasing);
    this.newTextDelay = 2000; // Delay between current and next text
    this.textArrayIndex = 0;
    this.charIndex = 0;
    this.effectTextArray = [this.typedText]
    
    this.typedAnimation()
  }

  typedAnimation = () => {
    this.setEffectEleHeight()
    this.typeEffect()
  }

  setEffectEleHeight = () => {
    const originalHeight  = this.effectTextSpan.offsetHeight
    this.effectTextSpan.style.display = 'none'
    this.style.height = originalHeight  + 'px';
  }

  typeEffect = () => {
    console.log("typing")
    if (this.charIndex < this.effectTextArray[this.textArrayIndex].length) {
      if(!this.typedCursor.classList.contains("typing")) this.typedCursor.classList.add("typing");
      this.typedTextEle.textContent += this.effectTextArray[this.textArrayIndex].charAt(this.charIndex);
      this.charIndex++;
      setTimeout(this.typeEffect, this.typingDelay);
    } 
    else {
      this.typedCursor.classList.remove("typing");
      setTimeout(this.eraseEffect, this.newTextDelay);
    }
  }

  eraseEffect = () =>  {
  	if (this.charIndex > 0) {
      if(!this.typedCursor.classList.contains("typing")) this.typedCursor.classList.add("typing");
      this.typedTextEle.textContent = this.effectTextArray[this.textArrayIndex].substring(0, this.charIndex-1);
      this.charIndex--;
      setTimeout(this.eraseEffect, this.erasingDelay);
    } 
    else {
      this.typedCursor.classList.remove("typing");
      this.textArrayIndex++;
      if(this.textArrayIndex>=this.effectTextArray.length) this.textArrayIndex=0;
      setTimeout(this.typeEffect, this.typingDelay + 1100);
    }
  }
}

customElements.define("typing-effect-element", typingEffect);

class alphaFilter extends HTMLElement{
  constructor(){
    super()
    this.listItemsEle = document.querySelectorAll(".tag-list li")
    this.selectItems = document.querySelectorAll(".alphabet_list span")
    this.emptyEle = document.querySelector(".empty-fiter")

    this.filterListItems("a")
    this.filterSelected()
    
  }

  filterSelected = () => {
    let filterStatus = false
    this.selectItems.forEach(item => {
      item.addEventListener("click", (e) => {
        const letter = item.dataset.alphabet
        if(this.filterListItems(letter)){
          this.emptyEle.classList.add("hide")
        }else{
          this.emptyEle.classList.remove("hide")
        }
        this.setActive(item.parentElement)
      })
    })
    
  }

  filterListItems = (letter) => {
    let filterStatus = false
    this.listItemsEle.forEach(item => {
      const tagHanlde = item.dataset.tag
      if(tagHanlde.charAt(0) === letter){
        item.classList.remove("hide")
        filterStatus = true
      }else{
        item.classList.add("hide")
      }
    })
    return filterStatus
  }

  setActive = (el) => {
    [...el.parentElement.children].forEach((sib) =>
      sib.classList.remove("active")
    );
    el.classList.add("active");
  };

}

customElements.define("alpha-filter", alphaFilter);


class testimonialCarousel extends HTMLElement{
  constructor(){
    super()

    this.carousel();
  }

  carousel = () => {
    const flktyCarousel = new Flickity( this, {
      // options
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      draggable: false,
      prevNextButtons: true,
      pageDots: false
    });
  }
}

customElements.define("aure-testimonial-carousel", testimonialCarousel)

class sectionStickyBanner extends HTMLElement{
  constructor(){
    super()

    this.eleHeight = 0
    this.position = "top"
    this.initProp()
  }

  initProp = () => {
    this.eleHeight = this.getHeight()
    this.getPostion()
    this.setPosition()
  }

  getPostion = () => {
    this.position = this.dataset.position
  }

  getHeight = () => {
    return this.offsetHeight
  }

  getMidPosition = (height) => {
    return height/2
  }

  setPosition = () => {
    if(this.position == "top"){
      this.style.top = -this.getMidPosition(this.eleHeight) + "px";
    }else{
      this.style.bottom = -this.getMidPosition(this.eleHeight) + "px";
    }
  }
}

customElements.define("section-sticky-banner", sectionStickyBanner)

/* toggle Element */
const toggleEles = document.querySelectorAll(".filter-handler-el")

toggleEles.forEach(toggleEle => {
  toggleEle.addEventListener("click", (e) => {
    e.preventDefault()
    if(toggleEle.hasAttribute("data-filter")){
      const icon = toggleEle.querySelector("span")
      const eleId = toggleEle.dataset.filter
      const container = document.querySelector(eleId)
      container.classList.toggle("show-filter")

      if(container.classList.contains("show-filter")){
        icon.innerHTML = "-"
      }else{
        icon.innerHTML = "+";
      }
    }
  })
})

const optionSelects = document.querySelectorAll(".filter-select")

optionSelects.forEach(optionSelect => {
  const clickEle = optionSelect.querySelector("label")
  clickEle.addEventListener("click", (e) => {
    e.preventDefault()
    const icon = optionSelect.querySelector("span")
    const optionEle = optionSelect.querySelector(".filter-section__option")
    optionEle.classList.toggle("show-option")

    if(optionEle.classList.contains("show-option")){
      icon.innerHTML = "-"
    }else{
      icon.innerHTML = "+";
    }
  })
})

/*window.addEventListener('mouseup',function(event){
  var filterHandle = document.querySelector('.filter-section__option');
  var filterTitleHandle = document.querySelector('.filter-select');
  console.log(event.target)
  if(event.target != filterHandle && event.target.parentNode != filterHandle &&
    event.target != filterTitleHandle && event.target.parentNode != filterTitleHandle){
    filterHandle.classList.remove("show-option")
    const icon = filterHandle.parentNode.querySelector("span")
    if(filterHandle.classList.contains("show-option")){
      icon.innerHTML = "-"
    }else{
      icon.innerHTML = "+";
    }
  }
}); */


class scrollSlider extends HTMLElement{
  constructor(){
    super()

    this.lastScroll = 0;
    this.flick = '';
    this.carouselEle = this.querySelector("slider-carousel");
    this.carousel();

    window.addEventListener('scroll', this.onScroll, false)
  }

  carousel = () => {
    this.flick = new Flickity( this.carouselEle, {
      
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      freeScroll: true,
      wrapAround: true,
    });
  }

  onScroll = () => {
    console.log("scroll")
    this.flick.isFreeScrolling = true;
    this.flick.startAnimation();
    let diff = window.scrollY - this.lastScroll
    this.lastScroll = window.scrollY


    this.flick.velocity += diff * -0.1;
    this.flick.x += this.flick.velocity;
    this.flick.velocity *= 1 - 0.03;

    let previousX = this.flick.x
    this.flick.positionSlider();
    this.flick.selectedIndex = this.flick.dragEndRestingSelect()
    this.flick.updateSelectedSlide()
    this.flick.settle( previousX );
  }
}

customElements.define("scroll-slider", scrollSlider)


class megaMenuStandard extends HTMLElement{
  constructor(){
    super();

    this.__menus = this.querySelectorAll(".mega-menu__handle")

    //Click Handler
    this.menuClickHandler()
  }

  menuClickHandler = () => {
    this.__menus.forEach((menu) => {
      menu.addEventListener("click", (e) => {
        e.preventDefault()
        const blockId = menu.dataset.id
        const blockContainer = this.querySelector(blockId)

        /*Menu Active*/
        this.__menuActiveHandler(menu)
        this.__blockActiveHandler(blockContainer)
      })
    })
  }

  __menuActiveHandler = (menu) => {
    this.setActive(menu.parentElement, "active__menu")
  }

  __blockActiveHandler = (block) => {
    this.setActive(block, "active__block")
  }

  setActive = (el, className) => {
    [...el.parentElement.children].forEach((sib) =>
      sib.classList.remove(className)
    );
    el.classList.add(className);
  };
}

customElements.define("mega-menu-standard", megaMenuStandard);

/*const navbarItems = document.querySelectorAll(".header__primary-nav > ul > li")
navbarItems.forEach((navbarItem) => {
  navbarItem.addEventListener('mouseover', (event) => {
    event.stopPropagation();
    const details = document.querySelector("details")
    details.setAttribute("aria-expanded", true)
    details.setAttribute("open", "")
  });
  navbarItem.addEventListener('mouseout', (event) => {
    event.stopPropagation();
    console.log(navbarItem.contains( event.target ))
    console.log(event.target.parentElement)
    if( navbarItem.contains( event.target.parent ) ){
      
	} else {
	  const details = document.querySelector("details")
      details.setAttribute("aria-expanded", false)
      details.removeAttribute("open")
	}
    
  });
})*/

const __checkImageExists = function(image_url){
  var http = new XMLHttpRequest();
  http.open('HEAD', image_url, false);
  http.send();
  return http.status != 404;
}

const observeImages = document.querySelectorAll(".js_imageObserver")
observeImages.forEach(function(observeImage){
  const imageUrl = observeImage.src;
  let imageStatus = __checkImageExists(imageUrl)

  if(!imageStatus){
    observeImage.closest("label").querySelector("span.option-title").classList.remove("sr-only")
  }else{
    observeImage.closest("label").classList.add("image__label")
    observeImage.closest("label").querySelector("span.option-title").classList.add("sr-only")
    observeImage.classList.remove("option-hide")
  }
})




